import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import EmailAccountFactory from "../../Entity/Factories/EmailAccountFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { EmailAccountInterface } from "../../Entity/Entities/EmailAccount/EmailAccountInterface";
import Translator from "../../Translation/Translator";

export default function* emailAccountInActivate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `deactivate-email-account/${action.payload?.emailAccount}`);
    const emailAccount: EmailAccountInterface = EmailAccountFactory.create(res.data.data);

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_SUCCESS,
      payload: {
        emailAccount: emailAccount
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-action-successful"),
        type: "success"
      }
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchEmailAccountInActivate() {
  yield takeEvery(Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_INACTIVE_START, emailAccountInActivate);
}
